const styles = () => ({
  root: {
    display: 'flex',
    gap: '6px',
  },
  bar: {
    width: 28,
    height: 4,
    borderRadius: '999px',
    transition: 'background 0.2s ease',
  },
})

export default styles
